import React from 'react';
import _ from 'lodash';
import { Card, CardHeader, CardContent } from '@mui/material';


import DocumentsButtons from './DocumentsButtons';

const DocumentsAndNotifications = () => (
  <>
    <Card>
      <CardHeader title="Dokumenty"></CardHeader>
      <CardContent>
        <DocumentsButtons />
      </CardContent>
    </Card>
  </>
);


export default DocumentsAndNotifications;
